import {mapGetters} from "vuex";

export const ROLE_LANDLORD = 1;
export const ROLE_TENANT = 2;
export const ROLE_BROKER = 3;

export default {

    computed: {
        ...mapGetters(['myId'])
    },


    methods: {
        isSignedByTenant(draftContract, id) {
            return draftContract.tenants.length > 0 && _(draftContract.tenants).filter(function (t) {
                return t.pivot.is_signed === true && t.id === id;
            }).size() > 0;
        },

        isSignedByAllTenants(draftContract) {
            return draftContract.tenants.length > 0 && _(draftContract.tenants).filter(function (t) {
                return t.pivot.is_signed === false;
            }).size() === 0;
        },

        isSentToTenants(draftContract) {
            return draftContract.tenants.length > 0 && _(draftContract.tenants).filter(function (t) {
                return t.pivot.is_sent === false;
            }).size() === 0;
        },

        getMyRole(draftContract) {
            if (draftContract.is_created_by_broker) {
                if (this.myId === draftContract.landlord.id)
                    return ROLE_LANDLORD;
                if (this.myId === draftContract.user_id)
                    return ROLE_BROKER;
                return ROLE_TENANT;
            } else {
                if (this.myId === draftContract.user_id)
                    return ROLE_LANDLORD;
                return ROLE_TENANT;
            }
        },

        getLandlordOwnerRoute(draftContract) {
            if (draftContract.is_completed) {
                // PDF View
            } else {
                if (draftContract.definition.landlord_type === 'private') {
                    // User input
                    // return '/screening-info/' + draftContract.id;
                    // But here we also need screening!
                    return '/contracts/digital-contract/' + draftContract.id + '/approve';
                } else {
                    return '/contracts/digital-contract/' + draftContract.id + '/approve';
                }
            }
        },

        getTenantRoute(draftContract) {
            if (draftContract.is_completed) {
                return '/contracts/digital-contract/' + draftContract.id;
            } else {
                if (!this.isSignedByTenant(draftContract, this.myId)) {
                    return '/screening-info/' + draftContract.id;
                } else {
                    return '/contracts/digital-contract/' + draftContract.id;
                }

                // Tenant signing: screening-info/70
                // /signing-review/70?review=1


            }
        },

        getBrokerRoute(draftContract) {
            if (draftContract.is_completed) {
                return '/contracts/digital-contract/status/' + draftContract.id;
            } else {
                if (draftContract.requires_landlord_approval === true && draftContract.landlord_approval_requested_at) {
                    if (this.isSignedByAllTenants(draftContract)) {
                        // all tenants signed
                        return '/signing-review/' + draftContract.id;
                    } else {
                        return '/contracts/digital-contract/status/' + draftContract.id;
                    }
                } else {
                    if (this.isSentToTenants(draftContract)) {
                        if (this.isSignedByAllTenants(draftContract)) {
                            // all tenants signed
                            return '/signing-review/' + draftContract.id;
                        } else {
                            return '/contracts/digital-contract/status/' + draftContract.id;
                        }
                    } else {
                        return '/contracts/digital-contract/edit/' + draftContract.id;
                    }
                }
            }
        },


        getDraftContractRoute(draftContract) {
            if (draftContract.is_created_by_broker) {
                if (this.getMyRole(draftContract) === ROLE_BROKER) {
                    return this.getBrokerRoute(draftContract);
                }

                if (this.getMyRole(draftContract) === ROLE_LANDLORD) {
                    return this.getLandlordOwnerRoute(draftContract)
                }

                if (this.getMyRole(draftContract) === ROLE_TENANT) {
                    return this.getTenantRoute(draftContract);
                }
            } else {

                if (this.getMyRole(draftContract) === ROLE_LANDLORD) {
                    return this.getBrokerRoute(draftContract);
                }

                if (this.getMyRole(draftContract) === ROLE_TENANT) {
                    return this.getTenantRoute(draftContract);
                }
            }
        },

        getDraftContractStatus(draftContract) {
            if (draftContract.is_completed) {
                return 'completed';
            }

            if (draftContract.requires_landlord_approval
                && draftContract.landlord_approval_requested_at
                && !draftContract.landlord_approved_at) {
                return 'awaitingapproval';
            }

            if (draftContract.requires_landlord_approval === true
                && draftContract.landlord_approval_requested_at !== null
                && draftContract.landlord_approved_at !== null
                && !this.isSentToTenants(draftContract)
            ) {
                return 'approvednotsentforsignature';
            }

            if (this.isSentToTenants(draftContract) && !this.isSignedByAllTenants(draftContract)) {

                if(this.getMyRole(draftContract) === ROLE_TENANT) {
                    return 'ready';
                }

                return 'awaitingtenantsignature';
            }

            if (this.isSignedByAllTenants(draftContract)) {

                if(this.getMyRole(draftContract) === ROLE_LANDLORD) {
                    return 'ready';
                }

                return 'awaitinglandlordsignature';
            }

            return 'inprogress';
        }


    }
}
